import PropTypes from 'prop-types';
import React, { Component } from 'react';
import MetaDataWrapper from 'modules/Common/containers/MetaDataWrapper';
import AdvertWrapper from 'modules/Common/components/AdvertWrapper';
import SimpleDonut from 'modules/Common/components/svg/SimpleDonut'
import SimpleBar from 'modules/Common/components/svg/SimpleBar'

// Need to do a version of bankers rounding to avoid percentages that are both N.5 rounding to a total of 101%
// Round to odd numbers to make 49.5:50.5 round to 49:51 (instead of 50:50)
// No need to avoid JS floating point issues because N.5 will never experience them
function oddRound(n) {
  const f = Math.floor(n);

  if ((n - f) == 0.5) { // limit to exactly half
    if ((f % 2) == 1) { // floor is odd
      return f; // round down to odd
    }
    else {
      return f + 1; // round up to even
    }
  }

  // by default, just round
  return Math.round(n);
}

// Availability of individual stats is flakey, so we need some helper functions
// to see if they're there, both individually and in groups
function hasProperty(match, property, team) {
  const stat = `team_statistics_${team}`;
  return match.hasOwnProperty(stat) && match[stat].hasOwnProperty(property.key);
}

function propertyExists(match, property) {
  if(!hasProperty(match, property, 'a') && !hasProperty(match, property, 'b')){
    return false;
  }

  //If property exists for one team but not the other, populate other as 0
  if(hasProperty(match, property, 'a') && !hasProperty(match, property, 'b')){
    match['team_statistics_b'][property.key] = 0;
  } else if(!hasProperty(match, property, 'a') && hasProperty(match, property, 'b')){
    match['team_statistics_a'][property.key] = 0;
  }
  return true;
}

function allPropertiesExist(match, properties) {
  return properties.reduce((result, property) => (result && propertyExists(match, property)), true);
}

function somePropertiesExist(match, properties) {
  return properties.reduce((result, property) => (result || propertyExists(match, property)), false);
}

// Helper for extracting (and possibly processing) an individual stat
function getData(match, extract) {
  return {
    a: extract(match.team_statistics_a),
    b: extract(match.team_statistics_b)
  }
}

const POSSESSION = {key: "possession"};
const SHOTS = [
  {key: "shotsOffTarget"},
  {key: "shotsOnTarget"}
];
const CORNERS = {key: "corners", label: "Corners"};
const PASSES = [
  {key: "totalPasses",    label: "Total Passes"},
  {key: "accuratePasses", label: "Accurate Passes"}
];
const FOULS = [
  {key: "foulsWon",      label: "Fouls Won"},
  {key: "foulsConceded", label: "Fouls Conceded"},
  {key: "yellowCards",   label: "Yellow Cards"},
  {key: "redCards",      label: "Red Cards"}
];
const OFFSIDES = [
  {key: "offsides",    label: "Offsides"}
];

export default class FootballMatchStats extends Component {
  static propTypes = {
    matchLabel: PropTypes.string,
    match: PropTypes.object
  }

  render() {
    require("./FootballMatchStats.scss");

    const {match, matchLabel} = this.props;

    // Curry (sorta) the helper functions to this scope
    const get = extract => getData(match, extract);
    const exists = property => propertyExists(match, property);
    const allOf = properties => allPropertiesExist(match, properties);
    const someOf = properties => somePropertiesExist(match, properties);

    return <div>
      {someOf([POSSESSION, ...SHOTS, CORNERS, ...PASSES, ...FOULS, ...OFFSIDES]) ? (
        <div className="football-match-stats">
          <MetaDataWrapper title={`${matchLabel} - Match Stats`}/>
          {exists(POSSESSION) &&
            <div className="football-match-statset">
              <h3 className="section-title">Possession</h3>
              <SimpleDonut unit="%" {...get(t => oddRound(t.possession))}/>
            </div>
          }
          {allOf(SHOTS) &&
            <div className="football-match-statset">
              <h3 className="section-title">Shots</h3>
              <div className="football-match-shotstats">
                <div className="football-match-shotstats-offtarget">
                  <div className="football-match-shotstats-label">Off Target</div>
                  <div className="football-match-shotstats-a">{match.team_statistics_a.shotsOffTarget}</div>
                  <div className="football-match-shotstats-b">{match.team_statistics_b.shotsOffTarget}</div>
                </div>
                <div className="football-match-shotstats-ontarget">
                  <div className="football-match-shotstats-label">On Target</div>
                  <div className="football-match-shotstats-a">{match.team_statistics_a.shotsOnTarget}</div>
                  <div className="football-match-shotstats-b">{match.team_statistics_b.shotsOnTarget}</div>
                </div>
              </div>
            </div>
          }
          {exists(CORNERS) &&
            <div className="football-match-statset">
              <h3 className="section-title">Corners</h3>
              <SimpleBar {...get(t => t.corners)}/>
            </div>
          }
          {someOf(PASSES) &&
            <div className="football-match-statset">
              {PASSES.map(stat => exists(stat) &&
                <div key={stat.key}>
                  <h3 className="section-title">{stat.label}</h3>
                  <SimpleBar {...get(t => t[stat.key])}/>
                </div>
              )}
            </div>
          }
          {someOf(FOULS) &&
            <div className="football-match-statset">
              {FOULS.map(stat => exists(stat) &&
                <div key={stat.key}>
                  <h3 className="section-title">{stat.label}</h3>
                  <SimpleBar {...get(t => t[stat.key])}/>
                </div>
              )}
            </div>
          }
          {someOf(OFFSIDES) &&
            <div className="football-match-statset">
              {OFFSIDES.map(stat => exists(stat) &&
                <div key={stat.key}>
                  <h3 className="section-title">{stat.label}</h3>
                  <SimpleBar {...get(t => t[stat.key])}/>
                </div>
              )}
            </div>
          }
        </div>
      ) : <div className="football-match-stats-none">
            <MetaDataWrapper title={`${this.props.matchLabel} - Match Stats`}/>
            No match stats are available.
          </div>}
      <AdvertWrapper ocSlot={["football", "leaderboard"]} additionalProperties={{view: "live"}} />
    </div>
  }
}



// WEBPACK FOOTER //
// ./modules/Football/components/FootballMatchStats.js